export enum AuthSteps {
  SendCode,
  SignUp,
  SignIn,
}
